// extracted by mini-css-extract-plugin
export default {"Banner":"ImageBanner_Banner__diRvb","MobileImage":"ImageBanner_MobileImage__k63Lb"};